Vue.component('ack-country-selector-confirm-modal', {
  delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
  template: '#ack-country-selector-confirm-modal',
  mixins: [stringHelpersMixins],
  created() {
    appLog.log('ack-country-selector-confirm-modal created')

    

    EventBus.$on('show-country-selector-confirm-modal', (country) => {
      appLog.log('on show-country-selector-confirm-modal', LOG_TYPE.debug)
      this.country = country
      this.showModal()
    })

    EventBus.$on('hide-country-selector-confirm-modal', () => {
      appLog.log('on hide-country-selector-confirm-modal', LOG_TYPE.debug)
      this.country = null
      this.hideModal()
    })


  },
  mounted(){
    this.modal = new bootstrap.Modal(document.getElementById('confirmCountryModal'), {})
  },
  props:{
    // country: { 
    //   type: Object,
    //   required: true
    // }
  },
  computed: {
    ...Vuex.mapGetters('localization', ['COUNTRY_SELECT', 'countryCode', 'currencyCode', 'currencySymbol' ]),

    

  },
  data() {
    return {
      modal: null,
      country: null
    }
  },
  methods: {
    //...Vuex.mapActions(['sayHi', 'someAction']),
    ...Vuex.mapActions('shop', ['checkoutCart', 'emptyCart']),
    showModal(){
      appLog.log('on confirm showModal', LOG_TYPE.debug)
      this.modal.show()
    },
    hideModal(){
      appLog.log('on confirm hideModal', LOG_TYPE.debug)
      this.country = null
      this.modal.hide()
      EventBus.$emit('show-country-selector-modal')
    },

    onQuickCheckoutClick(){
      this.checkoutCart()
      .then(url => {
        window.open(url, '_blank')
      })
    },

    onConfirmClick(){
      this.emptyCart()
    }

  },
  beforeDestroy() {

  },
  watch: {
    country: {
      handler() {


      },
      deep: true
    }
  }
})